import { Component, OnInit, Output, Input, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { GlobalService } from '../../services/global.service';
import { FilterService } from '../../services/filter.service';
import { ProjetcsService } from 'src/app/projects/projetcs.service';

@Component({
    selector: 'app-character-detail-filter',
    templateUrl: './character-detail-filter.component.html',
    styleUrls: ['./character-detail-filter.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CharacterDetailFilterComponent implements OnInit {

  @Input() project_id: any;
  @Input() filterArguments: any;
  @Input() viewData: any;
  @Input() isLocation: boolean = false;
  @Output() closeView = new EventEmitter<string>();
  @Output() notify = new EventEmitter<string>();

  viewFilterArguments: any;
  filteredSets: any = [];
  filteredElements: any = [];

  filter(){
		this.notify.emit(this.viewFilterArguments)
  }
  
  close() {
    this.closeView.emit()
  }

  filterSets(){
    this.filteredSets = [];
    if(this.viewFilterArguments.location) {
      for (const loc of this.viewFilterArguments.locations) {
        this.filteredSets =  this.filteredSets.concat(loc.sets);
      }
      this.viewFilterArguments.sets = this._fS.ElementInListElements(this.viewFilterArguments.sets, 'location_id', this.viewFilterArguments.locations, 'id');
    }
	}

  constructor(private _pS: ProjetcsService, private _fS: FilterService, public _gS: GlobalService) { }

  ngOnInit() {
    this.viewFilterArguments = Object.assign({}, this.filterArguments);
    if (!this.viewFilterArguments.scene_types) {
      this.viewFilterArguments.scene_types = [];
    }
  }
}
